import { colors, backgroundColors } from 'styles/colors'

export const light = {
    color: `${backgroundColors.formPromo}`,
    bgColor: `${colors.dark}`,
    bgColorHover: '#555',
    overlayColor: '#333333a8',
}
